import type { FC } from 'react';
import { ColorPicker, Flex, Input } from 'antd';
import styles from './preset-form.module.scss';

interface ColorFieldProps {
  value?: string | null;
  disabled?: boolean;
  onChange: (value: string) => void;
}

export const ColorField: FC<ColorFieldProps> = ({ value, disabled, onChange }) => {
  const resolvedValue = value || '#234EEE';

  return (
    <Flex gap={8} className={styles.colorField}>
      <ColorPicker
        value={resolvedValue}
        format="hex"
        disabledAlpha
        disabled={disabled}
        onChange={(color) => onChange(color.toHexString().toUpperCase())}
      />
      <Input
        value={value ?? ''}
        disabled={disabled}
        placeholder="#234EEE"
        maxLength={7}
        onChange={(event) => onChange(event.target.value)}
      />
    </Flex>
  );
};
